module.exports = __webpack_public_path__ + "img/T4-B-xh_14.36595e2c.png";